<template>
	<a-modal width="55%" title="详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" @cancel="onClose">
		<template #footer>
			<a-button type="primary" @click="onPass">接受</a-button>
			<a-button type="danger" @click="onNoPass">已拒绝</a-button>
		</template>
		<a-descriptions :column="2">
			<a-descriptions-item label="企业名称">{{ form.companyName }}</a-descriptions-item>
			<a-descriptions-item label="地区">{{ form.provject }}</a-descriptions-item>
			<a-descriptions-item label="详细地址">{{ form.detailedAddress }}</a-descriptions-item>
			<a-descriptions-item label="邮政编码">{{ form.postalCode }}</a-descriptions-item>
			<a-descriptions-item label="注册时间（企业成立时间）">{{ form.registerTime }}</a-descriptions-item>
			<a-descriptions-item label="入驻时间">{{ form.checkinTime }}</a-descriptions-item>
			<a-descriptions-item label="注册资本">{{ form.registerMoney }}</a-descriptions-item>
			<a-descriptions-item label="企业性质">
				<dict-render :dict-obj="dictObjs['businessScope']" v-if="form.businessScope"
					:text="form.businessScope"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="统一社会信用代码">{{ form.oraganizationCode }}</a-descriptions-item>
			<a-descriptions-item label="企业邮箱">{{ form.comEmail }}</a-descriptions-item>
			<a-descriptions-item label="企业法人">{{ form.corporation }}</a-descriptions-item>
			<a-descriptions-item label="法人电话">{{ form.contactsMobile }}</a-descriptions-item>
			<a-descriptions-item label="联系人">{{ form.linkman }}</a-descriptions-item>
			<a-descriptions-item label="联系电话">{{ form.phone }}</a-descriptions-item>
			<a-descriptions-item label="企业logo" name="companyLogo">
				<img-upload v-model:value="form.companyLogo" :showBtn="false" disabled />
			</a-descriptions-item>
			<a-descriptions-item label="营业执照" name="licenceFile">
				<img-upload v-model:value="form.licenceFile" :showBtn="false" disabled />
			</a-descriptions-item>
			<a-descriptions-item label="企业简介" name="description" :span="2">{{ form.description }}</a-descriptions-item>
		</a-descriptions>
	</a-modal>
</template>
<script>
import { formMixin, dictMixin } from "@/mixins";
import DictRender from "@/components/other/DictRender";
import { isPassInfo } from "@/api/educationService";
import { message } from "ant-design-vue";

export default {
	name: "companyInfo",
	components: { DictRender },
	mixins: [formMixin, dictMixin],
	data() {
		return {
			dictNames: 'businessScope',
			form: {
				id: null,
			},
		}
	},
	methods: {
		onPass() {
			this.postAction({
				url: isPassInfo.isPass,
				params: { isPass: 1, interviewInvitationId: this.form.interviewInvitationId }
			}).then(() => {
				message.success('操作成功！')
				this.onClose()
			})
		},
		onNoPass() {
			this.postAction({
				url: isPassInfo.isPass,
				params: { isPass: 2, interviewInvitationId: this.form.interviewInvitationId }
			}).then(() => {
				message.success('操作成功！')
				this.onClose()
			})
		},
	}
}
</script>
<style lang="less" scoped></style>